package globals

object AccelByteEnv
{
    /**
     * AccelByte user id. Required for most api calls.
     */
    var userId = ""

    var userName = ""

    var displayName = ""
}